import { render } from "./NotificationForm.vue?vue&type=template&id=08eabf24"
import script from "./NotificationForm.vue?vue&type=script&lang=js"
export * from "./NotificationForm.vue?vue&type=script&lang=js"

import "./NotificationForm.vue?vue&type=style&index=0&id=08eabf24&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "08eabf24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08eabf24', script)) {
    api.reload('08eabf24', script)
  }
  
  module.hot.accept("./NotificationForm.vue?vue&type=template&id=08eabf24", () => {
    api.rerender('08eabf24', render)
  })

}

script.__file = "src/components/training/NotificationForm.vue"

export default script